import { ReactNode, FC } from 'react';
import { classNames, isDefined } from 'support/helpers/generic/generic';

type SidebarProps = {
  side?: 'left' | 'right';
  children: ReactNode;
  bottomSlot?: ReactNode;
};

export const Sidebar: FC<SidebarProps> = ({ children, bottomSlot, side = 'right' }) => {
  const hasBottomSlot = bottomSlot
    ? Array.isArray(bottomSlot)
      ? bottomSlot.filter(isDefined).length > 0
      : true
    : false;

  return (
    <aside
      className={classNames(
        'flex flex-col justify-between border-gray-200 divide-y w-[300px]',
        side === 'left' ? 'border-r' : 'border-l',
      )}
      style={{ height: `var(--content-height)` }}
    >
      <div className="space-y-5 divide-y overflow-y-auto pb-5 *:px-5 *:pt-5">{children}</div>
      <div className="divide-y">
        {hasBottomSlot ? <div className="space-y-5 divide-y py-3 *:px-6">{bottomSlot}</div> : null}
      </div>
    </aside>
  );
};
